export class NativeStreamChatConnection {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "baseUrl",
            "baseName": "baseUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "model",
            "baseName": "model",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamChatConnection.attributeTypeMap;
    }
    constructor() {
    }
}
